module.exports = __webpack_public_path__ + "media/5.4e1cc1db.wav";